// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3oZwc","fares":"fares-3kAX3","content":"content-1xhiH","content_fullWidth":"content_fullWidth-2TOD-"};